export default[

    //推广列表
    {
        path: '/activity/activityInfo',
        component: () => import( '@/views/loud/activity/activityInfo.vue'),
        meta: {
            keepAlive:true,
            title: '推广活动效果闭环',
            isTabsPage: true
        }
    },


    //新增营销推广
    {
        path: '/activity/addActivity',
        component: () => import( '@/views/loud/activity/addActivity.vue'),
    },

    //新增营销推广
    {
        path: '/activity/seeActivity',
        component: () => import( '@/views/loud/activity/seeActivity.vue'),
    },

]
